$(".foo_title_btn1").click(function () {
  $("#fooNav").slideToggle(), $("#caretDown").toggleClass("rotate");
  var expanded = $(this).attr("aria-expanded") === "true";
  $(this).attr("aria-expanded", String(!expanded));
}),
  $(".foo_title_btn2").click(function () {
    $("#fooContact").slideToggle(), $("#caretDown2").toggleClass("rotate");
    var expanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", String(!expanded));
  }),
  $("#subNavOne").click(function () {
    $(".sub_nav_items").slideToggle();
    $("#subNavOne img").toggleClass("rotate");
    var expanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", String(!expanded));
  });
var swiper = new Swiper(".science-swiper", {
    spaceBetween: 100,
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: { 768: { slidesPerView: 1.2, spaceBetween: 0 } },
  }),
  swiper2 = new Swiper(".review-slider", {
    spaceBetween: 30,
    loop: true,
    autoplay: { delay: 5000, disableOnInteraction: false },
    pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: { 768: { spaceBetween: 80 } },
  }),
  swiper3 = new Swiper(".product-slider", {
    slidesPerView: 1.2,
    loop: true,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    centeredSlides: true,
    breakpoints: { 768: { slidesPerView: "auto" } },
    on: {
      init: function () {
        this.slideToLoop(0, 1);
      },
    },
  }),
  swiper5 = new Swiper(".featured-products-items-container", {
    breakpoints: {
      1140: { slidesPerView: 4.3 },
      1e3: { slidesPerView: 3.3 },
      641: { slidesPerView: 2.5 },
    },
    slidesPerView: 1.65,
    spaceBetween: 0,
    centeredSlides: market_handle != "us" ? true : false,
    loop: market_handle != "us" ? false : true,
    preventClicksPropagation: false,
    noSwipingSelector: "button",
    resistanceRatio: 1,
    a11y: false,
    watchSlidesProgress: true,
    navigation: { prevEl: ".swiper-nav-prev", nextEl: ".swiper-nav-next" },
    pagination: {
      el: ".featured-products-item-scrollbar .swiper-pagination",
      clickable: true,
      bulletClass: "pagination-item",
      bulletActiveClass: "pagination-active",
    },
  });
function swiper5_offset() {
  var e,
    i = jQuery(".featured-products-items-container").width();
  jQuery(window).outerWidth() >= 1140
    ? (e = (i / 4.3) * 0.15)
    : jQuery(window).outerWidth() <= 1139 && jQuery(window).outerWidth() >= 1e3
    ? (e = (i / 3.3) * 0.15)
    : jQuery(window).outerWidth() <= 999 && jQuery(window).outerWidth() >= 641
    ? (e = (i / 2.5) * 0.11)
    : jQuery(window).outerWidth() <= 640 && (e = 12);
  if (market_handle == "us") {
    swiper5.params.slidesOffsetBefore = e;
  } else {
    swiper5.params.slidesOffsetBefore = 0;
  }
  swiper5.update();
}

// function swiper5_offset() {
//   var slidesPerView;
//   var edgePaddingFactor;
//   var sliderWidth = jQuery(".featured-products-items-container").width();
//   var sliderOffset;
//   if (jQuery(window).outerWidth() >= 1140) {
//     slidesPerView = 4.3;
//     edgePaddingFactor = 0.15;
//     sliderOffset = (sliderWidth / slidesPerView) * edgePaddingFactor;
//   } else if (
//     jQuery(window).outerWidth() <= 1139 &&
//     jQuery(window).outerWidth() >= 1000
//   ) {
//     slidesPerView = 3.3;
//     edgePaddingFactor = 0.15;
//     sliderOffset = (sliderWidth / slidesPerView) * edgePaddingFactor;
//   } else if (
//     jQuery(window).outerWidth() <= 999 &&
//     jQuery(window).outerWidth() >= 641
//   ) {
//     slidesPerView = 2.5;
//     edgePaddingFactor = 0.11;
//     sliderOffset = (sliderWidth / slidesPerView) * edgePaddingFactor;
//   } else if (jQuery(window).outerWidth() <= 640) {
//     // slidesPerView = 1.65;
//     // edgePaddingFactor = 0.04;
//     // sliderOffset = 12;
//     swiper5.params.slidesOffsetBefore = 12;
//   }
//   //   swiper5.params.slidesOffsetBefore = 0;
//   swiper5.update();
// }
swiper5_offset(),
  $(document).ready(function () {
    swiper5_offset(),
      jQuery(window).resize(swiper5_offset),
      window.addEventListener("orientationchange", swiper5_offset);
    if (market_handle != "us") {
      swiper5.slideNext();
    }
  });


const swiper6 = new Swiper(".pdp_videos", {
  slidesPerView: 2.5,
  loop: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: { 992: { slidesPerView: 3.4 } },
  pagination: {
    el: ".pdp_videos_pagination",
    clickable: true,
  },
});
